import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, Modal, Form, Dropdown } from "react-bootstrap";
import { toast } from "react-toastify";
import Loader from '../../ApiCheck/Loader';
import { baseUrl } from "../../ApiCheck/Constant";
import { useSelector } from "react-redux";

function CategoryTable() {
  const user = useSelector((state) => state.user);

  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const fetchCategories = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/api/category`);
      setCategories(response.data);
    } catch (error) {
      toast.error("Failed to fetch categories");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user.user.role === "ADMIN") {
      fetchCategories();
    }
  }, []);

  const handleAddOrUpdate = async () => {
    try {
      if (selectedCategory) {
        await axios.put(`${baseUrl}/api/updatecategory/${selectedCategory._id}`, { name: categoryName });
        toast.success("Category updated");
      } else {
        await axios.post(`${baseUrl}/api/addcategory`, { name: categoryName });
        toast.success("Category added");
      }
      setShowModal(false);
      setCategoryName("");
      setSelectedCategory(null);
      fetchCategories();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
    }
  };

  const handleEdit = (category) => {
    setSelectedCategory(category);
    setCategoryName(category.name);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseUrl}/api/deletecategory/${id}`);
      toast.success("Category deleted");
      fetchCategories();
    } catch (error) {
      toast.error("Failed to delete category");
    }
  };

  return (
    <>
    <nav className="navbar bg-light">
        <h3>Categories</h3>
        <div>
          <button type="button" className="btn btn-primary btn-sm"
           onClick={() => { setShowModal(true); setSelectedCategory(null); setCategoryName("")}}
           >
            Add Category
          </button>
        </div>
      </nav>

      {isLoading ? (
        <Loader />
      ) : (
        <table className="table mt-3">
          <thead>
            <tr>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((cat) => (
              <tr key={cat._id}>
                <td>{cat.name}</td>
                   <td>
                                      <Dropdown>
                                        <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                                          ⋮
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                          <Dropdown.Item onClick={() => handleEdit(cat)}>Update</Dropdown.Item>
                                          <Dropdown.Item onClick={() => handleDelete(cat._id)}>
                                            Delete
                                          </Dropdown.Item>
                                        </Dropdown.Menu>
                                      </Dropdown>
                                    </td>

              </tr>
            ))}
          </tbody>
        </table>
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{selectedCategory ? "Update" : "Add"} Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="categoryName">
              <Form.Label>Category Name</Form.Label>
              <Form.Control
                type="text"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
          <Button variant="primary" onClick={handleAddOrUpdate}>Save</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CategoryTable;
